{
  "familyId": "GET-KOMMA-GETALLENLIJN",
  "questions": [
    {
      "id": "GET-KOMMA-GETALLENLIJN-001",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Op een getallenlijn van 0 tot 1, verdeeld in 10 gelijke stukken, welk getal hoort bij het zevende streepje?",
      "options": [
        "0,7",
        "0,07",
        "7",
        "0,3"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0,
            "end": 1,
            "marked": [0.7],
            "highlight": [0.7],
            "step": 0.1,
            "arrows": [{"from": 0, "to": 0.7, "label": "7 stappen van 0,1"}],
            "label": "10 stukken van 0 tot 1 → elk stukje = 0,1. Zevende streepje = 0,7"
          }
        }
      ],
      "conceptId": "komma_getallenlijn_tienden",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De lijn van 0 tot 1 is verdeeld in 10 stukken. Elk stukje = 1 ÷ 10 = 0,1 (één tiende). Het zevende streepje = 7 × 0,1 = 0,7. Controleer: 0,7 = zeven tienden ✓.",
        "distractorExplanations": {
          "0": "Goed! 10 stukken van 0 tot 1 → elk stukje = 0,1. Het zevende streepje = 7 × 0,1 = 0,7.",
          "1": "Je dacht waarschijnlijk dat elk stukje 0,01 is. Maar de lijn van 0 tot 1 met 10 stukken geeft elk stukje = 0,1 (niet 0,01). 0,07 zou kloppen als er 100 stukken waren. Onthoud: stap = bereik ÷ aantal stukken = 1 ÷ 10 = 0,1.",
          "2": "Je dacht waarschijnlijk dat de lijn van 0 tot 10 loopt. Maar de lijn loopt van 0 tot 1. Het zevende streepje is 0,7, niet 7. Onthoud: kijk altijd naar het begin en einde van de getallenlijn.",
          "3": "Je dacht waarschijnlijk dat je vanaf het einde telt. Maar je telt altijd vanaf het begin (links). Het derde streepje is 0,3, het zevende is 0,7. Onthoud: tel altijd vanaf 0 naar rechts."
        }
      }
    },
    {
      "id": "GET-KOMMA-GETALLENLIJN-002",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Op een getallenlijn van 3 tot 4, verdeeld in 10 stukken, welk getal hoort bij het vierde streepje?",
      "options": [
        "3,4",
        "3,04",
        "4,4",
        "0,4"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 3,
            "end": 4,
            "marked": [3.4],
            "highlight": [3.4],
            "step": 0.1,
            "arrows": [{"from": 3, "to": 3.4, "label": "4 stappen van 0,1 vanaf 3"}],
            "label": "Start bij 3, elk stukje = 0,1. Vierde streepje = 3,4"
          }
        }
      ],
      "conceptId": "komma_getallenlijn_niet_nul",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De lijn loopt van 3 tot 4, verdeeld in 10 stukken. Stap = (4 − 3) ÷ 10 = 0,1. Begin bij 3. Het vierde streepje = 3 + 4 × 0,1 = 3 + 0,4 = 3,4. Controleer: 3,4 ligt tussen 3 en 4 ✓.",
        "distractorExplanations": {
          "0": "Goed! Start bij 3, elk streepje = 0,1. Vierde streepje = 3 + 0,4 = 3,4.",
          "1": "Je dacht waarschijnlijk dat elk stukje 0,01 is. Maar bij 10 stukken van 3 tot 4 is elk stukje 0,1, niet 0,01. 3,04 zou kloppen als er 100 stukken waren. Onthoud: stap = bereik ÷ aantal stukken = 1 ÷ 10 = 0,1.",
          "2": "Je dacht waarschijnlijk dat de lijn van 4 tot 5 loopt. Maar de lijn loopt van 3 tot 4. Het vierde streepje is 3,4, niet 4,4. Onthoud: kijk altijd naar het begin van de getallenlijn.",
          "3": "Je dacht waarschijnlijk dat de lijn bij 0 begint. Maar de lijn begint bij 3. Het vierde streepje = 3 + 0,4 = 3,4, niet 0,4. Onthoud: tel altijd vanaf het startpunt van de lijn."
        }
      }
    },
    {
      "id": "GET-KOMMA-GETALLENLIJN-003",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Tussen welke twee hele getallen ligt 7,85 op de getallenlijn?",
      "options": [
        "tussen 7 en 8",
        "tussen 8 en 9",
        "tussen 7,8 en 7,9",
        "tussen 78 en 79"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Positie op de getallenlijn bepalen",
            "content": "Kijk naar het getal vóór de komma. Dat vertelt je tussen welke twee hele getallen het getal ligt. 7,85 → het hele getal is 7 → het ligt tussen 7 en 8.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_getallenlijn_positie",
      "variantIndex": 3,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Kijk naar het getal vóór de komma in 7,85: dat is 7. 7,85 is groter dan 7 maar kleiner dan 8. Dus 7,85 ligt tussen 7 en 8 op de getallenlijn. Controleer: 7 < 7,85 < 8 ✓.",
        "distractorExplanations": {
          "0": "Goed! 7,85 ligt tussen 7 en 8. Het hele getal vóór de komma is 7.",
          "1": "Je dacht waarschijnlijk dat 7,85 groter is dan 8. Maar 7,85 is kleiner dan 8 — het ligt nog vóór 8 op de getallenlijn. Onthoud: kijk naar het getal vóór de komma: 7 → tussen 7 en 8.",
          "2": "Tussen 7,8 en 7,9 is ook correct, maar de vraag vraagt naar hele getallen. Het antwoord is: tussen 7 en 8. Onthoud: hele getallen zijn getallen zonder decimalen.",
          "3": "Je dacht waarschijnlijk dat de komma er niet toe doet en dat 7,85 hetzelfde is als 785. Maar 7,85 is een kommagetal tussen 7 en 8. Onthoud: de komma scheidt het hele getal (7) van de decimalen (85)."
        }
      }
    },
    {
      "id": "GET-KOMMA-GETALLENLIJN-004",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Op een getallenlijn van 0 tot 0,1 (verdeeld in 10 stukken) staat een pijl op het derde streepje. Welk getal is dat?",
      "options": [
        "0,03",
        "0,3",
        "0,003",
        "3"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stapgrootte berekenen",
            "content": "Stap = bereik ÷ aantal stukken. Bereik van 0 tot 0,1 = 0,1. Aantal stukken = 10. Stap = 0,1 ÷ 10 = 0,01. Derde streepje = 3 × 0,01 = 0,03.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_getallenlijn_honderdsten",
      "variantIndex": 4,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De lijn loopt van 0 tot 0,1 in 10 stukken. Stap = 0,1 ÷ 10 = 0,01 (honderdsten). Derde streepje = 3 × 0,01 = 0,03. Controleer: 0,03 ligt tussen 0 en 0,1 ✓.",
        "distractorExplanations": {
          "0": "Goed! Van 0 tot 0,1 in 10 stukken → stap = 0,01. Derde streepje = 0,03.",
          "1": "Je dacht waarschijnlijk dat de lijn van 0 tot 1 loopt. Maar de lijn loopt van 0 tot 0,1 — dat is tien keer kleiner. Elk stukje = 0,01, niet 0,1. Onthoud: kijk altijd naar het einde van de getallenlijn.",
          "2": "Je dacht waarschijnlijk dat de lijn van 0 tot 0,01 loopt. Maar de lijn loopt van 0 tot 0,1. Elk stukje = 0,01, niet 0,001. Onthoud: stap = bereik ÷ aantal stukken = 0,1 ÷ 10 = 0,01.",
          "3": "Je dacht waarschijnlijk dat de lijn van 0 tot 10 loopt. Maar de lijn loopt van 0 tot 0,1. Het derde streepje = 0,03, niet 3. Onthoud: kijk altijd naar het begin en einde van de getallenlijn."
        }
      }
    },
    {
      "id": "GET-KOMMA-GETALLENLIJN-005",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Welk kommagetal ligt precies halverwege 2,4 en 2,6?",
      "options": [
        "2,5",
        "2,45",
        "2,55",
        "2,10"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Halverwege op de getallenlijn",
            "content": "Het getal halverwege twee getallen bereken je door ze op te tellen en door 2 te delen. Of: neem het verschil, deel door 2, en tel op bij het kleinste getal.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_getallenlijn_halverwege",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Halverwege 2,4 en 2,6: tel op en deel door 2. 2,4 + 2,6 = 5,0. 5,0 ÷ 2 = 2,5. Of: het verschil is 0,2, de helft is 0,1. 2,4 + 0,1 = 2,5. Controleer: 2,5 − 2,4 = 0,1 en 2,6 − 2,5 = 0,1 ✓.",
        "distractorExplanations": {
          "0": "Goed! Halverwege 2,4 en 2,6 = (2,4 + 2,6) ÷ 2 = 2,5.",
          "1": "Je dacht waarschijnlijk dat 2,45 halverwege ligt. Maar 2,45 − 2,4 = 0,05 en 2,6 − 2,45 = 0,15 — dat is niet gelijk. Halverwege = 2,5. Onthoud: controleer of de afstand aan beide kanten gelijk is.",
          "2": "Je dacht waarschijnlijk dat 2,55 halverwege ligt. Maar 2,55 − 2,4 = 0,15 en 2,6 − 2,55 = 0,05 — dat is niet gelijk. Halverwege = 2,5. Onthoud: controleer of de afstand aan beide kanten gelijk is.",
          "3": "Je dacht waarschijnlijk dat je de tienden optelt: 4 + 6 = 10 → 2,10. Maar halverwege bereken je door het gemiddelde te nemen: (2,4 + 2,6) ÷ 2 = 2,5. Onthoud: halverwege = gemiddelde van de twee getallen."
        }
      }
    }
  ]
}